<template>
  <div class="h-screen w-screen grid grid-cols-12 bg-grey-50">
    <!-- <v-overlay>
      <v-progress-circular color="#FBB040" indeterminate size="64"></v-progress-circular>
    </v-overlay> -->
    <div
      class="lg:col-span-6 col-span-full px-8 py-32 lg:p-32 bg-white grid content-center relative h-screen"
    >
      <!--LoginForm.vue - molecules component-->
      <login-form @loading="handleLoading" class="m-auto lg:max-w-md" />
      <span
        class="text-xs text-center text-grey bottom-4 left-0 right-0 mx-auto absolute"
      >
        Copyright © 2022 - 2023<br />
        Bản quyền thuộc về Lê Phong Mobile
      </span>
    </div>
    <div class="lg:col-span-6 hidden lg:block">
      <img class="h-screen w-full" src="@/assets/imgs/login-background.png" alt="" />
    </div>
  </div>
</template>

<script>
import LoginForm from "~/components/molecules/LoginForm";
export default {
  components: {
    LoginForm,
  },
  metaInfo() {
    return {
      title: "Đăng nhập | Hệ thống quản lý",
    };
  },
  data() {
    return {
      isLoadingActions: false,
    };
  },
  methods: {
    handleLoading(isLoadingActions) {
      this.isLoadingActions = isLoadingActions;
    },
  },
};
</script>
